import Swiper, { Autoplay, Navigation, EffectCreative } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let sectorsSwiperWr = document.querySelectorAll('.sectors-swiper-wr');

sectorsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, EffectCreative],
      observer: true,
      observeParents: true,
      spaceBetween: 15,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      breakpoints: {
        1023: {
          spaceBetween: 24,
          slidesPerView: 3,
        },
        1200: {
          spaceBetween: 46,
          slidesPerView: 3,
        },
      },
    });

    swiperObserver(swiper);
  }
});